import { uuid } from './rng.js';

/**
 * Made-up names, so nobody has to give a real one.
 *
 * The table needs to tell players apart; it does not need to know who they
 * are. Generating a name by default means the ordinary path collects no
 * personal data at all — a player can still type their own name if they want
 * to, but that becomes a choice they make rather than a question they are
 * asked.
 *
 * Both lists are hand-written rather than taken from the word packs: a
 * comprehensive dictionary contains plenty of words nobody wants attached to
 * a child at a family table.
 */
const COLOURS = [
  'Amber', 'Brass', 'Cobalt', 'Copper', 'Coral', 'Cream', 'Damson', 'Ember',
  'Fern', 'Flint', 'Ginger', 'Gold', 'Hazel', 'Indigo', 'Ivory', 'Jade',
  'Lilac', 'Linen', 'Maple', 'Mint', 'Moss', 'Ochre', 'Olive', 'Opal',
  'Pearl', 'Pewter', 'Plum', 'Rose', 'Rust', 'Saffron', 'Sage', 'Sand',
  'Scarlet', 'Silver', 'Slate', 'Teal', 'Thistle', 'Umber', 'Violet', 'Willow',
];

const CREATURES = [
  'Badger', 'Bittern', 'Curlew', 'Dormouse', 'Eagle', 'Falcon', 'Ferret',
  'Finch', 'Gannet', 'Hare', 'Heron', 'Hedgehog', 'Ibis', 'Jackdaw', 'Kestrel',
  'Lapwing', 'Linnet', 'Magpie', 'Marten', 'Merlin', 'Osprey', 'Otter', 'Owl',
  'Pelican', 'Pipit', 'Plover', 'Puffin', 'Raven', 'Redwing', 'Robin',
  'Seal', 'Shrew', 'Siskin', 'Sparrow', 'Starling', 'Stoat', 'Swift',
  'Teal', 'Vole', 'Wagtail', 'Weasel', 'Wren',
];

/** A fresh, harmless name such as "Copper Wren". */
export function nickname(): string {
  const id = uuid().replace(/-/g, '');
  const a = parseInt(id.slice(0, 8), 16) % COLOURS.length;
  const b = parseInt(id.slice(8, 16), 16) % CREATURES.length;
  // "Teal Teal" is the one collision worth avoiding.
  const creature = CREATURES[b] === COLOURS[a]
    ? CREATURES[(b + 1) % CREATURES.length] : CREATURES[b];
  return `${COLOURS[a]} ${creature}`;
}
